import { render, staticRenderFns } from "./SearchLabels.vue?vue&type=template&id=226ab906&scoped=true"
import script from "./SearchLabels.vue?vue&type=script&lang=js"
export * from "./SearchLabels.vue?vue&type=script&lang=js"
import style0 from "./SearchLabels.vue?vue&type=style&index=0&id=226ab906&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ab906",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226ab906')) {
      api.createRecord('226ab906', component.options)
    } else {
      api.reload('226ab906', component.options)
    }
    module.hot.accept("./SearchLabels.vue?vue&type=template&id=226ab906&scoped=true", function () {
      api.rerender('226ab906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/SearchLabels.vue"
export default component.exports